/**
 * RAFAELS ANTWORT RAEUMT "VOR DIR" SOFORT (23.09.2026, sein Wort: "ja- so muss das sein !!!!").
 *
 * Anlass, gemessen am Fall b-muehl-bericht-staging-20260923 (cui-usage.jsonl):
 *   12:20:05  Klick, der Guide springt weiter (`advance_after_input`) — das ging schon.
 *   12:20:35  der Sende-POST steht noch in der Warteschlange des Browsers, Frist ab.
 *   12:22:43  erst jetzt nimmt der Server die Antwort an und setzt den Sitzungssaal.
 * Dazwischen stand die Karte weiter unter "Vor dir", Rafael oeffnete sie um 12:23:11 von
 * dort erneut — und bekam "Ueberholter Stand" fuer seine eigene, laengst gegebene Antwort.
 *
 * KEIN RATEN: der Raum, in den die Karte hier zieht, ist genau der, den der Server beim
 * Eingang derselben Eingabe setzt (`/entscheidungen/antworten` und `/nachricht` an den
 * Berater -> sitzungssaal, `/raum` -> der gewaehlte Raum). Die Eingabe selbst liegt schon
 * im Sendespeicher dieses Fensters; gewartet wird nur noch auf ihre Ankunft.
 *
 * ANDERS ALS DER FILTER VOM 15.09. (siehe guide-abschluss-sofort.ts): die Karte verlaesst
 * keinen Raum ins Nichts, sie steht im Zielraum. Summe der Raumkoepfe == offene Buehnen
 * gilt weiter.
 *
 * ZURUECK IN DIE SERVERSICHT, sobald eine davon zutrifft:
 * - der Server zeigt denselben Raum (er hat aufgeholt),
 * - der Server hat den Raum NACH der Eingabe neu gesetzt (etwa der Berater legt eine neue
 *   Frage vor) — dann ist seine Sicht die juengere,
 * - der Auftrag ist blockiert (die Antwort ist nicht angekommen; die Frage muss wieder
 *   vor ihm stehen, der Sendestatus nennt den Grund),
 * - der Auftrag ist abgeraeumt und der Server hat nach GEDULD_MS noch nicht aufgeholt.
 */
import type { Job } from './GuideSendQueue';

export const GEDULD_MS = 120_000;

export type Verschoben = { raum: string; seit: number; fertigSeit?: number };

/** Der Raum, den der Server beim Eingang dieser Eingabe setzt — oder null. */
export function zielraumDerEingabe(j: Job): string | null {
  if (j.close || j.state === 'blocked') return null;
  if (j.raum) return j.raum;
  return 'sitzungssaal';
}

/** Haelt `merk` mit dem Sendespeicher in Takt. `sendungen`: Buehnen-ID -> Auftrag. */
export function merkeEingaben(sendungen: ReadonlyMap<string, Job>, merk: Map<string, Verschoben>, jetzt: number): void {
  for (const [id, j] of sendungen) {
    const ziel = zielraumDerEingabe(j);
    const alt = merk.get(id);
    if (!ziel) { merk.delete(id); continue; }
    if (!alt || alt.raum !== ziel || alt.fertigSeit !== undefined) merk.set(id, { raum: ziel, seit: alt?.raum === ziel ? alt.seit : jetzt });
  }
  for (const [id, m] of merk) if (!sendungen.has(id) && m.fertigSeit === undefined) m.fertigSeit = jetzt;
}

/**
 * Der Raum, in dem die Karte JETZT steht. `raumSeit` ist der Zeitpunkt, zu dem der
 * Server den aktuellen Raum gesetzt hat (ISO), soweit bekannt.
 */
export function lokalerRaum(
  b: { id: string; raum: string }, raumSeit: string | undefined,
  merk: Map<string, Verschoben>, jetzt: number, geduldMs = GEDULD_MS,
): string {
  const m = merk.get(b.id);
  if (!m) return b.raum;
  const serverJuenger = raumSeit !== undefined && Date.parse(raumSeit) >= m.seit;
  const geduldAus = m.fertigSeit !== undefined && jetzt - m.fertigSeit >= geduldMs;
  if (b.raum === m.raum || serverJuenger || geduldAus) { merk.delete(b.id); return b.raum; }
  return m.raum;
}
